import rollbar from '@cred/shared/rollbar'

export default class LogService {
  static error(message) {
    console.error(message)
    rollbar.error(message)
  }
}
